/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Pagination } from '../models/Pagination';
import { SamlIdentityProvider } from '../models/SamlIdentityProvider';

export class SamlIdentityProviderConfigsResponse {
  'samlIdentityProviders': Array<SamlIdentityProvider>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "samlIdentityProviders",
      "baseName": "samlIdentityProviders",
      "type": "Array<SamlIdentityProvider>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SamlIdentityProviderConfigsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

